export const FAVORITE_TYPE = {
  REPORT: "REPORT",
  SEARCH: "SEARCH",
  MODEL: "MODEL",
  VENDOR: "VENDOR",
  DATAREPORT: "DATAREPORT",
}

export const MESSAGE_TYPE = {
  ALREADY_EXIST: "alreadyExist",
  SUCCESS: "success",
  SAVE_ERROR: "saveError",
  REQUIRED: "isRequired",
}
